export const fruitfulGreen = '#027a48';
